import { BaseController } from './BaseController';
import { get, post } from '../Utils/helpers';

export default class FormController extends BaseController {
    id = 'FormController';
    
    init() {
        this.root = this.getRoot();
        this.csrfToken = this.getData(this.root, 'csrf');
        this.endpoint = this.getData(this.root, 'endpoint');
        
        this.notificationBox = this.singleChildNode('notification-box');

        this.btnSubmit = this.singleChildNode('btn-submit');
        this.btnSubmit.addEventListener('click', this.handleVerificationCallback);
    }

    handleVerificationCallback = () => {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LdwBscfAAAAAIX-XF2zokI6XfrK8ulELKrbjhu9', {action: 'submit'}).then((token) => {
                let form = new FormData(this.root);
                form.append('token', token);
                
                post(this.endpoint,(resp) => {
                    console.log(resp);
                    if (resp.target.readyState === XMLHttpRequest.DONE) {
                        if (resp.target.status === 0 || (resp.target.status >= 200 && resp.target.status < 400)) {
                            console.log('readystate was changed');
                            console.log(resp);
                            this.btnSubmit.disabled = true;
                            this.btnSubmit.classList.add('btn-success');
                            this.btnSubmit.innerHTML = '&#10004;';
                        } else {
                            let oldTextVal = this.btnSubmit.innerHTML;
                            this.btnSubmit.classList.add('btn-failed');
                            this.btnSubmit.innerHTML = '&#10007;';
                            
                            setTimeout(()=>{
                                this.btnSubmit.innerHTML = oldTextVal;
                                this.btnSubmit.classList.remove('btn-failed');
                            }, 5000);
                        }
                    }
                },{'X-CSRFToken': this.csrfToken}, form);
            });
          });  
    };
}